<template>
	<div>
		
		<!--<v-overlay :value="isLoading">-->
		<!--	<v-progress-circular-->
		<!--		indeterminate-->
		<!--		size="64"-->
		<!--		color="secondary"-->
		<!--	></v-progress-circular>-->
		<!--</v-overlay>-->
		
		<template>
			<v-row>
				<v-col v-if="bando.id != 26">
					<v-sheet
						rounded
						outlined
						class="px-10 py-16 d-flex flex-column justify-space-between"
						height="100%"
					>
						<div class="text-center">
							<img
								src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/brochure.png"
								alt="Materiale Informativo"
								height="200"
							>
						</div>
						<div>
							<div class="text-h5 mb-3 text-center font-weight-medium primary--text">
								Brochure informativa
							</div>
							<div class="mb-6 text-center">
								La nostra brochure informativa ti illustrerà in modo chiaro e conciso come funziona il Servizio Cliccatori e ti mostrerà anche i risultati tangibili che puoi ottenere utilizzandolo
							</div>
						</div>
						<div class="text-center">
							<v-btn
								color="secondary"
								@click="download(user.cliente.path_brochure_personalizzata || 'Brochure white label.pdf', 'path_brochure')"
								:loading="downloadingBrochureInformativa"
							>
								Scarica la Brochure {{ user.cliente.path_brochure_personalizzata !== null ? 'Personalizzata' : '' }}
							</v-btn>
						</div>
					</v-sheet>
				</v-col>
				
				<v-col>
					<v-sheet
						rounded
						outlined
						class="px-10 py-16 d-flex flex-column justify-space-between"
						height="100%"
					>
						<div class="text-center">
							<img
								src="https://s3.eu-central-1.amazonaws.com/manager.clickday.images/accordo.png"
								alt="Materiale Informativo"
								height="200"
							>
						</div>
						<div>
							<div class="text-h5 mb-3 text-center font-weight-medium primary--text">
								Accordo di Prenotazione
							</div>
							<div class="mb-6 text-center">
								Se hai firmato con noi un Accordo di Prenotazione, qui troverai una copia
							</div>
						</div>
						<div class="text-center">
							<v-btn
								color="secondary"
								@click="download(accordo?.path_accordo_prenotazione, 'path_accordo_prenotazione')"
								:disabled="!accordo?.path_accordo_prenotazione || isLoadingAccordo"
								:loading="downloadingAccordoPrenotazione"
							>
								Scarica l'Accordo
							</v-btn>
						</div>
					</v-sheet>
				</v-col>
				
				<v-col>
					<v-sheet
						rounded
						outlined
						class="px-10 py-16 d-flex flex-column justify-space-between"
					>
						<div>
							<video style="width: 100%; height: auto" controls>
								<source :src="videoSource" type="video/mp4">
								Your browser does not support the video tag.
							</video>
						</div>
						
						<div class="text-h5 mb-3 mt-5 text-center">
							{{ videoTitle }}
						</div>
						<div class="mb-6 text-center">
							{{ videoDescription }}
						</div>
						<div class="text-center mb-6">
							<social-sharing
								:title="socialSharingVideoTitle"
								:url="socialSharingVideoSource"
							></social-sharing>
						</div>
						<small>
							Disclaimer: Questo video è destinato esclusivamente a un utilizzo commerciale privato e riservato ai nostri clienti. Non può essere pubblicato sui social o condiviso con chi non è tuo cliente!
						</small>
					</v-sheet>
				</v-col>
			</v-row>
		</template>
		
	</div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
	data() {
		return {
			isLoadingAccordo: false,
			accordo: null,
			videoSource: "https://video68746.s3.eu-central-1.amazonaws.com/Video+Clickday.mp4",
			videoTitle: 'Valorizza la tua strategia di marketing con i cliccatori professionisti di ClickDay.it',
			videoDescription: 'Guarda e usa per i tuoi clienti il nostro video esplicativo sul Servizio Cliccatori. Tramite la comparazione di un vero click day, affrontato da un operatore normale e da un nostro professionista, mostriamo quanto è importante affidarsi al Servizio Cliccatori.',
			downloadingBrochureInformativa: false,
			downloadingAccordoPrenotazione: false,
			socialSharingVideoTitle: 'Ciao, ti invio questo breve messaggio per condividere con te un video che mostra quanto sia fondamentale affidarsi a un cliccatore professionista per l\'invio della domanda il giorno del ClickDay. Per vedere il video clicca sul link.',
			socialSharingVideoSource: 'https://bit.ly/VideoClickDay'
		}
	},
	
	computed: {
		...mapGetters({
			user: 'auth/user',
			bando: 'shared/bando'
		}),
		isLoading() {
			return this.isLoadingAccordo;
		}
	},
	
	created() {
		this.getAccordo()
	},
	
	mounted() {
		// setTimeout(() => {
		// 	console.log(this.$tours)
		// 	this.$tours['guida'].nextStep()
		// 	// this.$tours.trendingTour.start('#step-2')
		// }, 3000)
	},
	
	methods: {
		getAccordo() {
			this.isLoadingAccordo = true;
			axios.get(`/api/accordi/by-cliente-id/${this.user.cliente.id}`)
				.then(response => {
					this.accordo = response.data;
				})
				.finally(() => {
					this.isLoadingAccordo = false;
				})
		},
		download(path, key) {
			const fileName = this.getFileNameFromPath(path);
			if (key == 'path_brochure') this.downloadingBrochureInformativa = true;
			else if (key == 'path_accordo_prenotazione') this.downloadingAccordoPrenotazione = true;
			axios.post('/api/storage/download',
				{
					path: path
				},
				{
					responseType: 'blob'
				})
				.then(response => {
					saveAs(response.data, fileName);
				})
				.finally(() => {
					if (key == 'path_brochure') this.downloadingBrochureInformativa = false;
					else if (key == 'path_accordo_prenotazione') this.downloadingAccordoPrenotazione = false;
				})
		},
	},
};
</script>